import React from 'react'
import { Footer } from '../../organims/footer'
import { Button, Card, Col, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom';
import { Fade } from 'react-awesome-reveal'
import { projectsData } from '../../../Assets/data/projects';

export const Portfolio = () => (
  <>
    <Container id='home'>
      <h2>Experience lab</h2>
      <p>From brief to usable experience.</p>

      <Row xs={1} md={2} className="g-4 mb-5">
        {projectsData.map((val) => (
          <Fade top>
            <Col key={val.id}>
              <Card className='py-0'>
                <Card.Img alt='' src={require("../../../Assets/Images/" + `${val.image}` + "")} />
                <Card.Body>
                  <Card.Title className='text-dark'>
                    {val.name}
                    </Card.Title>
                  <Card.Text className='text-dark'>
                    {val.type}
                  </Card.Text>
                  <div className='d-flex justify-content-between'>
                    <Link
                      to={`/portfolio/${val.id}`}
                      aria-label={`Ver detalles de ${val.name}`}
                    >
                      <Button
                        className={'d-block d-sm-inline-block mx-auto ' + (document.documentElement.clientWidth <= 500 ? 'w-100' : '')}
                        variant='outline-primary'
                      >
                        Read case study
                      </Button>
                    </Link>
                    <a aria-label={("Open " + `${val.name}` + " website")} href={val.link} target='_blank' >
                      <Button className={'d-block d-sm-inline-block ' + (document.documentElement.clientWidth <= 500 ? 'w-100' : '')} variant='primary'>
                        <img src={require("../../../Assets/icons/icon-world.png")} width='25px' />
                      </Button>
                    </a>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Fade>
        ))}
      </Row>
    </Container>
    <Footer />
  </>
)
